import React from 'react';
import { Col, Row } from 'reactstrap';
import home from '../../assets/images/commons/home.svg';
import withRouter from './withRouter';

interface BreadCrumbProps {
    title?: string;
    pageTitle?: string;
    subTitle?: { label: string; link: string }[];
    isTab?: boolean;
    tabsList?: any[];
    activeTab?: any;
    handleActiveTab?: (tab: any) => void;
    className?: string;
    handleBack?: (path: string) => void;
    router?: any;
    breadcrumbFlag?: boolean;
    isTitle?: boolean;
}

const BreadCrumb = ({
    isTitle,
    title,
    className,
    subTitle,
    isTab,
    tabsList,
    activeTab,
    handleActiveTab,
    handleBack,
    breadcrumbFlag,
    ...props
}: BreadCrumbProps) => {
    return (
        <React.Fragment>
            <Row>
                <Col xs={12} className="my-3">
                    {/* path titles */}
                    {subTitle && subTitle.length > 0 && (
                        <div className="page-title-box-sub d-sm-flex align-items-center fs-16 bg-light-bg-grey">
                            {subTitle?.length > 1 && (
                                <span>
                                    <img
                                        className="cursor-pointer mb-1"
                                        src={home}
                                        alt="home"
                                        onClick={() => props?.router?.navigate(subTitle?.[0]?.link)}
                                    />
                                    <span className="mb-sm-0 fw-400 primary-color cursor-pointer">{'\u00A0'}/</span>
                                </span>
                            )}

                            {subTitle.map((sub: { label: string; link: any; combined?: any }, index: number) => {
                                if (subTitle.length - 1 === index) {
                                    return <span className="bg-grey-2">{sub?.label}</span>;
                                }
                                return (
                                    <span
                                        className="mb-sm-0 fw-400 primary-color cursor-pointer"
                                        onClick={() =>
                                            sub?.combined
                                                ? props.router.navigate(sub.link.pathname, { state: sub.link.state })
                                                : props.router.navigate(sub.link)
                                        }
                                    >
                                        {sub?.label}
                                        {'\u00A0'}/{'\u00A0'}
                                    </span>
                                );
                            })}
                        </div>
                    )}

                    {/* main title  */}
                    {isTitle && (
                        <div className="page-title-box d-sm-flex align-items-center fs-16">
                            <span className="mb-sm-0">{title}</span>
                        </div>
                    )}

                    {/* tabs */}
                    {isTab && tabsList && tabsList?.length > 0 && activeTab && Object.keys(activeTab)?.length > 0 && (
                        <div className="tab-header d-flex align-items-center gap-3 ms-4 border-bottom">
                            {tabsList?.map((tab: any) => (
                                <div
                                    key={tab.key}
                                    onClick={() => handleActiveTab?.(tab)}
                                    className={`d-flex flex-column justify-content-center align-items-start height-56 font-weight-500 line-height-24 font-size-16 cursor-pointer ${
                                        activeTab?.key === tab.key ? 'text-primary border-2 border-bottom border-primary' : 'text-secondary'
                                    }`}
                                >
                                    {tab.label}
                                </div>
                            ))}
                        </div>
                    )}
                </Col>
            </Row>
        </React.Fragment>
    );
};

export default withRouter(BreadCrumb);
